
import { useEffect } from 'react';

interface PlausibleAnalyticsProps {
  domain: string;
  scriptSrc?: string;
  trackLocalhost?: boolean;
}

export const PlausibleAnalytics: React.FC<PlausibleAnalyticsProps> = ({
  domain,
  scriptSrc = 'https://plausible.io/js/script.js',
  trackLocalhost = false,
}) => {
  useEffect(() => {
    // Skip tracking on localhost unless explicitly enabled
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1';
    
    if (isLocalhost && !trackLocalhost) {
      return;
    }
    
    // Create and load the Plausible script
    const script = document.createElement('script');
    script.defer = true;
    script.setAttribute('data-domain', domain);
    script.src = scriptSrc;
    
    document.head.appendChild(script);
    
    // Clean up the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, [domain, scriptSrc, trackLocalhost]);
  
  return null;
};

export default PlausibleAnalytics;
